import { IReview } from '@/app/[locale]/_types'
import { Button } from '@/components/ui/button'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import { Rating, RoundedStar } from '@smastrom/react-rating'
import dayjs from 'dayjs'
import React, { useState } from 'react'

const Card = ({ data }: { data: IReview }) => {
  const [showMore, setShowMore] = useState(true)

  return (
    <Box py={4} key={data.id}>
      <Flex justifyContent={'space-between'} alignItems={'end'}>
        <Stack>
          <Text>{data?.client_name}</Text>
          <Rating
            readOnly
            style={{ maxWidth: 100 }}
            value={data.rating || 5}
            itemStyles={{
              itemShapes: RoundedStar,
              activeFillColor: '#FFC500',
              inactiveFillColor: '#E0E8F1',
            }}
          />
        </Stack>
        <Text color={'gray.600'} fontSize={'sm'}>
          {dayjs(data.created_at).format('MMMM D, YYYY')}
        </Text>
      </Flex>
      <Box mt={4}>
        <Text fontSize={'sm'} lineHeight={'18.2px'}>
          {showMore
            ? data.review_message
            : data.review_message?.substring(0, 170) + '...'}
        </Text>
        {data.review_message?.length > 170 && (
          <Button
            w="full"
            fontSize="xs"
            width="fit-content"
            fontWeight={400}
            color="primary.500"
            textDecor="underline"
            transform={`translateY(${showMore ? 0 : -5}px)`}
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? 'Уменьшить' : 'Читать дальше'}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default Card
